import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportDetailsComponent } from '../passport-details/passport-details.component';
import { Router } from '@angular/router';
import { PassportDetailsStore } from '../shared/passport-details.store';
import { UiStateService } from '../shared/ui-state.service';
import { BasePassportCellComponent } from '../shared/base-passport-cell.component';

@Component({
  selector: 'app-scheduler-passport-cell',
  standalone: true,
  imports: [CommonModule, PassportDetailsComponent],
  templateUrl: '../shared/passport-cell.template.html',
  styleUrl: './scheduler-passport-cell.component.css'
})
export class SchedulerPassportCellComponent extends BasePassportCellComponent {
  protected get personaName(): string {
    return 'scheduler';
  }

  constructor(router: Router, details: PassportDetailsStore, ui: UiStateService) {
    super(router, details, ui);
  }
}


